import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings"}/>
}
